import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, onMounted, watch } from "vue";
import store from "@/vue/planning/store/store";
import documentReady from "@/vue/planning/logic/documentReady";

// components
import Search from "@/vue/planning/components/search.vue";
import Result from "@/vue/planning/components/result.vue";
import Summary from "@/vue/planning/components/summary.vue";
import TransportSwitch from "@/vue/planning/components/transportSwitch.vue";
import OopsBanner from "@/vue/planning/components/oopsBanner.vue";
import Overlay from "@/vue/common/overlay.vue";
import ErrorMessage from "@/vue/planning/components/common/errorMessage.vue";

// computed
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes";

interface Props {
	keyUpdater: string; // WTF is this, Ido?
}

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  props: {
    keyUpdater: null
  },
  setup(__props: any) {

const props = __props as {
	keyUpdater: string; // WTF is this, Ido?
}



// computed
const errorText: ComputedRef<string> = computed(() => {
	return store.state.content[store.state.errorMessageOpen];
});

// methods
const handleErrorMessageClose = () => {
	store.commit("setErrorMessageOpen", "");
};

onMounted(async () => {
	await documentReady(store);
	window.addEventListener("closeMonCompteModal", async () => {
		await documentReady(store);
	});

	store.commit("setScreenType", window.screenSizeManager.screenType);
	window.addEventListener("screenTypeChange", () => {
		store.commit("setScreenType", window.screenSizeManager.screenType);
	});
});

// watch
watch(
	() => store.state.bodyOverflowHidden,
	(newValue: boolean) => {
		if (newValue) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-hidden");
		}
	}
);

return { __sfc: true,props, errorText, handleErrorMessageClose, store, Search, Result, Summary, TransportSwitch, OopsBanner, Overlay, ErrorMessage, availableTransportPackCodes }
}

})